import { render, staticRenderFns } from "./MultiCheckboxes.vue?vue&type=template&id=0027a8f3&scoped=true&"
import script from "./MultiCheckboxes.vue?vue&type=script&lang=js&"
export * from "./MultiCheckboxes.vue?vue&type=script&lang=js&"
import style0 from "./MultiCheckboxes.vue?vue&type=style&index=0&id=0027a8f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0027a8f3",
  null
  
)

export default component.exports